module.exports = __webpack_public_path__ + "img/June.05d61528.png";